import { getErrorCode } from '@onefootprint/fetch-hosted';

/** E144: the workflow already finished, usually in another tab, so it rejects writes. */
export const isOnboardingCompleted = (error: unknown): boolean => getErrorCode(error) === 'E144';
